import React, { Component } from "react";
import { AxiosResponse } from "axios";
import { getRequest } from "../../../../utils/httpRequest";
import {
  ReviewResource,
  ReviewsResource,
} from "../../../../stores/ReviewsStore/Types";
import Review from "./Review";

interface Props {
  courseSlug: string;
  rating: number;
}

interface State {
  loading: boolean;
  totalReviews: ReviewResource[];
  reviews: ReviewResource[];
  totalFiveStarReviews: number;
  showMore: boolean;
}

class Reviews extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      reviews: [],
      totalReviews: [],
      showMore: false,
      totalFiveStarReviews: 0,
      loading: true,
    };
  }

  componentDidMount() {
    const { courseSlug } = this.props;

    if (!courseSlug) return null;

    return getRequest(`/api/courses/${courseSlug}/reviews.json`).then(
      (response: AxiosResponse<ReviewsResource>) => {
        const { reviews, total_five_star_reviews } = response.data;
        this.setState({
          totalReviews: reviews,
          reviews: reviews.slice(0, 6),
          showMore: reviews.length > 6,
          totalFiveStarReviews: total_five_star_reviews,
          loading: false,
        });
      },
    );
  }

  showMoreReviews = (e) => {
    e.preventDefault();

    const { reviews, totalReviews } = this.state;
    this.setState(
      {
        reviews: totalReviews.slice(0, reviews.length + 6),
      },
      this.checkShouldShowMore,
    );
  };

  checkShouldShowMore = () => {
    const { reviews, totalReviews } = this.state;

    if (totalReviews.length === reviews.length) {
      this.setState({ showMore: false });
    }
  };

  render() {
    const { rating } = this.props;
    const { loading, reviews, totalFiveStarReviews, showMore } = this.state;

    if (!loading && reviews.length === 0) return null;

    return (
      <section
        className="reviews"
        id="course-reviews"
        aria-labelledby="reviews-title"
      >
        {loading && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}

        <div className="container">
          <div className="head">
            <h2 className="section-title" id="reviews-title">
              What learners{" "}
              <span className="nobr">
                <em className="hl">are saying</em>.
              </span>
            </h2>
          </div>

          <div
            className="stat-strip"
            role="list"
            aria-label="Course statistics at a glance"
          >
            <div className="stat" role="listitem">
              <strong>{rating?.toFixed(1)}/5</strong>
              <span className="l">Avg rating</span>
            </div>
            <div className="stat" role="listitem">
              <strong>80%+</strong>
              <span className="l">Completion rate</span>
            </div>
            <div className="stat" role="listitem">
              <strong>170+</strong>
              <span className="l">Countries</span>
            </div>
          </div>

          <div className="review-grid">
            {reviews.map((review) => (
              <Review key={review.id} review={review} />
            ))}
          </div>

          {showMore && (
            <div className="all-row">
              <button
                type="button"
                className="btn btn-outline"
                onClick={this.showMoreReviews}
              >
                Show all reviews
              </button>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default Reviews;
